const lowerCaseBoolValue = value => {
  const valueToLowerCase = value.toLowerCase();

  if (valueToLowerCase === 'true' || valueToLowerCase === 'false') {
    return valueToLowerCase;
  }

  return value;
};

export default lowerCaseBoolValue;
//# sourceMappingURL=lowerCaseBoolValue.js.map